<template>
    <cmpRec v-bind:name="name"
                   v-bind:pkColumn="pkColumn"
                   v-bind:fields="fields"
                   v-bind:parent="parent"
                   v-bind:header="header"></cmpRec>
</template>

<script>
    import i18n from '@/i18n'
    import cmpRec from "@/components/common/cmpRec"

    export default {
        components: {
            cmpRec
        },
        computed: {
            fields() {
                return [
                    { "key": "UserId", "label": i18n.t('component.Login.UserId.label') },
                    { "key": "UserName", "label": i18n.t('component.Login.UserName.label') },
                    { "key": "RoleId", "label": i18n.t('component.Login.RoleId.label') },
                    { "key": "RoleName", "label": i18n.t('component.Login.RoleName.label') }
                ]
            },
            header() {
                return i18n.t('component.Login.recHeader')
            }
        },
        data() {

            return {
                name: "Login",
                pkColumn: "LoginId",
                parent: {}
            };
        }
    }
</script>